<script>
  import JumpTem from '../bannerTemplate/JumpTem.vue'
  import imageUpload from '@/components/ImageUpload/index.vue'
  import { getDriverAreaTree } from '@/api/vehicle/vehicle-manage'
  import { getBannerPosition } from '../../config/format'
  import DefaultBannerDialog from './DefaultBannerDialog.vue'

  export default {
    name: 'BannerPosition',
    components: { JumpTem, imageUpload, DefaultBannerDialog },
    props: {
      value: {
        type: Object,
        default: () => ({})
      },
      slotKeys: {
        type: Array,
        default: () => []
      },
      // 是否使用tab风格
      useTabStyle: {
        type: Boolean,
        default: true
      },
      // 是否编辑
      isEdit: {
        type: Boolean,
        default: false
      },
      // 是否简化模式（用于图5的场景）
      isSimpleMode: {
        type: Boolean,
        default: false
      },
      // 默认banner列表
      defaultBanners: {
        type: Array,
        default: () => []
      },
      // 是否允许缓存数据
      allowCache: {
        type: Boolean,
        default: false
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    data() {
      return {
        rules: {
          slotKey: [{ required: true, message: '请选择banner位置', trigger: 'change' }],
          marketImgUrl: [
            { required: !this.isSimpleMode, message: '请上传标题文字图', trigger: 'change' }
          ],
          imgUrl: [{ required: !this.isSimpleMode, message: '请上传banner图', trigger: 'change' }],
          marketText: [
            { required: !this.isSimpleMode, max: 6, message: '不超过6个字', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback()
                  return
                }

                // 使用更精确的表情符号检测方法
                // 这个正则表达式专门匹配表情符号，不会误判数字
                const emojiRegex =
                  /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u

                if (emojiRegex.test(value)) {
                  callback(new Error('名称不能包含表情符号'))
                  return
                }

                callback()
              },
              trigger: ['blur', 'change']
            }
          ],
          defAdId: [{ required: true, message: '请选择默认banner', trigger: 'change' }],
          name: [
            { required: true, message: '请输入banner名称', trigger: 'blur' },
            { max: 30, message: '不超过30个字', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback()
                  return
                }

                // 使用更精确的表情符号检测方法
                // 这个正则表达式专门匹配表情符号，不会误判数字
                const emojiRegex =
                  /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u

                if (emojiRegex.test(value)) {
                  callback(new Error('名称不能包含表情符号'))
                  return
                }

                callback()
              },
              trigger: ['blur', 'change']
            }
          ],
          sort: [
            { required: true, message: '请输入权重', trigger: ['blur', 'change'] },
            {
              pattern: /^(?:[1-9]|10)$/,
              message: '请输入小于等于10的正整数',
              trigger: ['blur', 'change']
            }
          ],
          startTime: [{ required: true, message: '请选择展示时间', trigger: 'change' }],
          areaIdList: [{ required: true, message: '请选择展示地区', trigger: 'change' }],
          allArea: [{ required: true, message: '请选择展示地区', trigger: 'change' }],
          dateRange: [{ required: true, message: '请选择展示时间', trigger: 'change' }]
        },
        dataMap: {}, // 存储各个位置的数据
        validationErrors: {}, // 存储校验错误信息
        activeTab: '', // 当前激活的tab
        currentSlotKey: '', // 当前选中的位置
        getDriverAreaTree,
        tempId: '',
        defaultBannerDialogVisible: false,
        isInitialized: false, // 添加初始化标记
        loadingCache: true
      }
    },
    created() {
      console.log('初始化')
      // 初始化组件状态
      this.initializeComponent()

      // 延迟设置初始化完成标记，避免初始监听触发缓存
      this.$nextTick(() => {
        setTimeout(() => {
          this.isInitialized = true
          console.log('BannerPosition initialized')
        }, 100) // 延迟100毫秒确保所有初始数据加载完成
      })
    },
    computed: {
      // 获取当前激活的表单引用
      activeFormRef() {
        return this.$refs[`${this.currentSlotKey}_bannerForm`]
      },
      // 获取当前激活的JumpTem引用
      activeJumpTemRef() {
        return this.$refs[`${this.currentSlotKey}_JumpTem`]
      },
      // 当前位置的数据，用于双向绑定
      currentData() {
        return this.dataMap[this.currentSlotKey] || {}
      },
      // 根据当前位置过滤默认banner列表
      filteredDefaultBanners() {
        return (slotKey) => {
          return this.defaultBanners.filter((banner) => banner.slotKey === slotKey)
        }
      },
      positionTitle() {
        return (item) => {
          return getBannerPosition({ slotKey: item })
        }
      },
      width() {
        const map = new Map([
          ['banner1', 150],
          ['banner2', 150],
          ['banner3', 150],
          ['banner4', 150],
          ['left', 326],
          ['right_top', 320],
          ['right_bottom', 320],
          ['left_top', 320],
          ['left_bottom', 320],
          ['right', 326],
          ['line', 710]
        ])
        return map.get(this.activeTab)
      },
      height() {
        const map = new Map([
          ['banner1', 200],
          ['banner2', 200],
          ['banner3', 200],
          ['banner4', 200],
          ['left', 412],
          ['right_top', 200],
          ['right_bottom', 200],
          ['left_top', 200],
          ['left_bottom', 200],
          ['right', 412],
          ['line', 210]
        ])
        return map.get(this.activeTab)
      }
    },
    watch: {
      value: {
        handler(val) {
          const { templateId } = val
          this.tempId = templateId
          if (val && val.slotKey && val.slotKey !== this.currentSlotKey) {
            // 当value中的slotKey变化时，更新当前位置和相关状态
            this.updateCurrentPosition(val.slotKey)
          }
        },
        deep: true
      },
      slotKeys: {
        handler() {
          // 当可用位置列表变化时，重新初始化数据
          this.initializeDataMap()
        }
      },
      // 监听currentSlotKey变化
      currentSlotKey(newKey, oldKey) {
        if (newKey !== oldKey) {
          // 更新内部状态
          this.activeTab = newKey

          // 仅同步slotKey变化，这是父组件可能需要的信息
          this.$emit('change', {
            ...this.value,
            slotKey: newKey
          })
        }
      },
      dataMap: {
        handler(newVal) {
          // 只有初始化完成且允许缓存时才写入缓存
          if (!this.isInitialized || !this.allowCache) return

          try {
            const adGroupCache = localStorage.getItem('adGroupCache')
            let newData = {}
            if (adGroupCache) {
              newData = JSON.parse(adGroupCache)
              for (const newValKey in newVal) {
                if (newData.dataMap) {
                  newData.dataMap[newValKey] = {
                    ...newVal[newValKey],
                    areaIdList: newVal[newValKey].areaIdList
                      ? newVal[newValKey].areaIdList.map((item) =>
                          Array.isArray(item) ? item.at(-1) : item
                        )
                      : undefined
                  }
                }
              }
            } else {
              newData = {
                baseForm: {},
                dataMap: newVal
              }
            }
            localStorage.setItem('adGroupCache', JSON.stringify(newData))
          } catch (error) {
            console.error('缓存数据失败:', error)
          }
        },
        deep: true
      }
    },
    methods: {
      // 初始化组件
      initializeComponent() {
        // 初始化当前位置
        this.currentSlotKey = this.value.slotKey || this.slotKeys[0]

        // 初始化每个位置的数据
        this.initializeDataMap()

        // 初始化激活的tab
        this.activeTab = this.currentSlotKey
      },

      // 更新当前位置和相关状态
      updateCurrentPosition(slotKey) {
        this.currentSlotKey = slotKey
        this.updateSlotKeyInDataMap(slotKey)
        this.activeTab = slotKey
      },

      // 初始化数据映射
      initializeDataMap() {
        console.log('初始化数据', this.value, this.slotKeys, this.defaultBanners, this.isEdit)
        if (this.isEdit) {
          // 编辑模式下，只初始化当前slotKey的数据
          // const slotKey = this.value.slotKey
          for (let i = 0; i < this.slotKeys.length; i++) {
            const key = this.slotKeys[i]
            const banner = this.defaultBanners.find((item) => item.templateSloKey === key)
            if (banner) {
              // 处理展示渠道格式，将字符串转换为数字ID
              let displayChannelList = []
              if (banner.displayChannel) {
                displayChannelList = banner.displayChannel.split(',')
              }

              // 确保displayChannelList正确初始化
              this.$set(this.dataMap, key, {
                name: banner.name || '',
                sort: banner.sort || 0,
                startTime: banner.startTime || '',
                endTime: banner.endTime || '',
                allArea: banner.allArea !== undefined ? banner.allArea : 1,
                areaIdList: banner.areaIdList || [],
                displayChannelList,
                // 只复制banner相关的特定字段，避免覆盖核心字段
                imgUrl: banner.imgUrl || '',
                marketImgUrl: banner.marketImgUrl || '',
                marketText: banner.marketText || '',
                defaultBannerId: banner.defaultBannerId || '',
                // JumpTem组件需要的字段
                jumpType: banner.jumpType,
                jumpUrl: banner.jumpUrl,
                pageUrl: banner.pageUrl || '',
                pageUrlType: banner.pageUrlType || 2, // 默认为外部链接
                appId: banner.appId || '',
                appletOriginalId: banner.appletOriginalId || '',
                slotKey: banner.templateSloKey,
                dateRange:
                  banner.startTime && banner.endTime ? [banner.startTime, banner.endTime] : [],
                defImgUrl: banner.defImgUrl,
                defName: banner.defName,
                defAdId: banner.defId
              })
            } else {
              this.$set(this.dataMap, key, {
                slotKey: key,
                name: '',
                sort: 1,
                startTime: '',
                endTime: '',
                allArea: 1,
                areaIdList: [],
                displayChannelList: [],
                marketImgUrl: '',
                imgUrl: '',
                marketText: '',
                defaultBannerId: '',
                // JumpTem组件需要的字段
                pageUrl: '',
                pageUrlType: '', // 默认为空
                appId: '',
                appletOriginalId: '',
                defImgUrl: '',
                defName: '',
                defAdId: ''
              })
            }
          }
        } else {
          // 新增模式，初始化所有位置的数据
          for (let i = 0; i < this.slotKeys.length; i++) {
            const key = this.slotKeys[i]
            if (!this.dataMap[key]) {
              this.$set(this.dataMap, key, {
                slotKey: key,
                name: '',
                sort: 1,
                startTime: '',
                endTime: '',
                allArea: 1,
                areaIdList: [],
                displayChannelList: [],
                marketImgUrl: '',
                imgUrl: '',
                marketText: '',
                defaultBannerId: '',
                // JumpTem组件需要的字段
                pageUrl: '',
                pageUrlType: '', // 默认为外部链接
                appId: '',
                appletOriginalId: ''
              })
            }
          }
        }

        // 确保有slotKey
        this.updateSlotKeyInDataMap(this.currentSlotKey)
      },

      // 更新所有位置的数据中的slotKey
      updateSlotKeyInDataMap(slotKey) {
        // 更新当前位置的数据
        if (this.dataMap[slotKey]) {
          this.$set(this.dataMap[slotKey], 'slotKey', slotKey)
        }
      },

      // 校验单个表单
      validateBannerForm() {
        return new Promise((resolve, reject) => {
          const slotKey = this.currentSlotKey

          // 如果是简化模式，只校验基本表单
          if (this.isSimpleMode) {
            // 获取当前激活的表单
            const formRef = this.activeFormRef

            // 如果找不到表单，直接拒绝
            if (!formRef) {
              reject(new Error(`找不到位置 ${slotKey} 的Banner表单`))
              return
            }

            // 校验Banner表单
            formRef[0].validate((valid) => {
              if (valid) {
                resolve(this.dataMap[slotKey])
              } else {
                reject(new Error(`位置 ${slotKey} 的Banner表单校验失败`))
              }
            })
            return
          }

          // 获取当前激活的JumpTem组件
          const jumpTemRef = this.activeJumpTemRef

          // 如果找不到JumpTem组件，直接拒绝
          if (!jumpTemRef) {
            reject(new Error(`找不到位置 ${slotKey} 的跳转表单`))
            return
          }

          // 校验JumpTem组件
          jumpTemRef[0]
            .validateForm()
            .then((jumpTemData) => {
              // 获取当前激活的表单
              const formRef = this.activeFormRef

              // 如果找不到表单，直接拒绝
              if (!formRef) {
                reject(new Error(`找不到位置 ${slotKey} 的Banner表单`))
                return
              }

              // 校验Banner表单
              formRef[0].validate((valid) => {
                if (valid) {
                  // 确保将jumpTemData中的所有字段保存到dataMap中
                  // 特别是处理displayChannel字段
                  Object.keys(jumpTemData).forEach((key) => {
                    this.$set(this.dataMap[slotKey], key, jumpTemData[key])
                  })

                  // 合并JumpTem数据和当前表单数据
                  const validData = {
                    ...this.dataMap[slotKey]
                  }

                  // 处理展示渠道格式，确保与JumpTem组件兼容
                  if (validData.displayChannelList && validData.displayChannelList.length > 0) {
                    // 转换为字符串格式
                    const channelMap = {
                      1: '微信小程序',
                      2: 'APP',
                      3: '云闪付',
                      4: '支付宝小程序'
                    }

                    // 如果是数字ID，转换为字符串标签
                    validData.displayChannelList = validData.displayChannelList.map((channel) => {
                      return channelMap[channel] || channel
                    })

                    // 更新displayChannel字段
                    validData.displayChannel = validData.displayChannelList.join(',')
                  }

                  resolve(validData)
                } else {
                  reject(new Error(`位置 ${slotKey} 的Banner表单校验失败`))
                }
              })
            })
            .catch((error) => {
              reject(error)
            })
        })
      },

      // 校验所有表单
      validateAllForms(slotKeys) {
        return new Promise((resolve, reject) => {
          // 清空校验错误记录
          this.validationErrors = {}

          // 如果不使用Tab风格且不允许多选，则只校验当前选中的位置
          if (!this.useTabStyle) {
            // 只校验当前选中的位置
            this.validateBannerForm()
              .then((validData) => {
                // 只返回当前位置的数据和slotKey，不合并父组件的value
                resolve({
                  ...validData,
                  slotKey: this.currentSlotKey
                })
              })
              .catch((error) => {
                reject(error)
              })
            return
          }

          // 获取要校验的位置列表
          const keysToValidate = slotKeys || this.slotKeys

          // 记住当前位置
          const originalSlotKey = this.currentSlotKey

          // 使用顺序校验而不是并行校验，以确保位置切换的准确性
          const validateSequentially = async () => {
            // 依次校验每个位置
            for (let i = 0; i < keysToValidate.length; i++) {
              const slotKey = keysToValidate[i]

              // 设置当前位置
              this.currentSlotKey = slotKey
              this.activeTab = slotKey

              try {
                // 等待校验完成
                await this.validateBannerForm()
              } catch (error) {
                // 记录校验失败的位置和错误信息
                this.validationErrors[slotKey] = error.message || '校验失败'

                // 已经在失败的位置，直接抛出错误
                throw new Error(`位置 ${slotKey} 校验失败: ${error.message || '校验失败'}`)
              }
            }

            // 全部校验通过，恢复原来的位置
            this.currentSlotKey = originalSlotKey
            this.activeTab = originalSlotKey

            // 只返回必要的数据：当前slotKey和所有位置的数据
            return {
              slotKey: this.currentSlotKey,
              allPositionsData: { ...this.dataMap }
            }
          }

          // 执行顺序校验
          validateSequentially()
            .then((result) => resolve(result))
            .catch((error) => reject(error))
        })
      },

      // 处理上一步
      handlePrev() {
        const currentIndex = this.slotKeys.findIndex((key) => key === this.currentSlotKey)
        const prevIndex = Math.max(0, currentIndex - 1)
        const prevSlotKey = this.slotKeys[prevIndex]

        // 设置当前位置
        this.currentSlotKey = prevSlotKey
        this.activeTab = prevSlotKey

        return prevIndex // 返回新索引，供父组件参考
      },

      // 处理下一步
      handleNext() {
        const currentIndex = this.slotKeys.findIndex((key) => key === this.currentSlotKey)
        const nextIndex = Math.min(this.slotKeys.length - 1, currentIndex + 1)
        const nextSlotKey = this.slotKeys[nextIndex]

        // 设置当前位置
        this.currentSlotKey = nextSlotKey
        this.activeTab = nextSlotKey

        return nextIndex // 返回新索引，供父组件参考
      },

      // 获取当前位置索引
      getCurrentIndex() {
        return this.slotKeys.findIndex((key) => key === this.currentSlotKey)
      },

      // 获取所有数据
      getAllData() {
        return {
          currentSlotKey: this.currentSlotKey,
          allPositionsData: this.dataMap
        }
      },

      // 更新dataMap中指定位置和属性的值
      updateDataMap(slotKey, prop, value) {
        if (this.dataMap[slotKey]) {
          this.$set(this.dataMap[slotKey], prop, value)
        }
      },

      getImg(url, prop, slotKey) {
        this.updateDataMap(slotKey, prop, url)
      },

      // 处理位置切换事件
      slotKeyChange(val) {
        // 处理从el-tabs传来的事件对象
        let newSlotKey = val

        // 如果是tab-click事件，从事件对象中提取选项卡名称
        if (val && val.name) {
          newSlotKey = val.name
        }

        // 更新当前位置
        this.currentSlotKey = newSlotKey
      },

      // 处理日期范围变更
      handleDateRangeChange(val, slotKey) {
        if (val) {
          this.updateDataMap(slotKey, 'startTime', val[0])
          this.updateDataMap(slotKey, 'endTime', val[1])
        } else {
          this.updateDataMap(slotKey, 'startTime', '')
          this.updateDataMap(slotKey, 'endTime', '')
        }
      },

      // 日期选择器开始日期配置
      pickerOptionStart() {
        return {
          disabledDate: (time) => {
            return Date.now() - 3600 * 1000 * 24 > time.getTime()
          }
        }
      },

      // 处理区域格式化
      fieldFormat(data) {
        data.forEach((item) => {
          item.children &&
            item.children.forEach((child) => {
              child.children = null
            })
        })
        const search = (list) => {
          for (let i = 0; i < list.length; i++) {
            const { children } = list[i]
            if (Array.isArray(children) && children.length > 0) {
              list[i].childAreaManage = children
              search(children)
            }
          }
        }

        search(data)
        return data
      },

      openDefaultBannerDialog() {
        this.defaultBannerDialogVisible = true
      },
      handleDefaultBannerConfirm(banner) {
        // 更新当前 slotKey 对应的 defaultBanner
        if (this.currentSlotKey && this.dataMap[this.currentSlotKey]) {
          this.$set(this.dataMap[this.currentSlotKey], 'defImgUrl', banner.imgUrl)
          this.$set(this.dataMap[this.currentSlotKey], 'defName', banner.name)
          // 同时更新 defaultBannerId 字段，保持兼容性
          this.$set(this.dataMap[this.currentSlotKey], 'defAdId', banner ? banner.id : '')
        }
        this.defaultBannerDialogVisible = false
        // 发送更新后的整个 dataMap
        this.$emit('change', { ...this.value, dataMap: this.dataMap })
      },

      // 从缓存加载数据
      loadCachedData(cachedDataMap) {
        if (!cachedDataMap || Object.keys(cachedDataMap).length === 0) return
        this.loadingCache = false
        try {
          // 将缓存的 dataMap 数据合并到当前 dataMap
          for (const key in cachedDataMap) {
            if (this.slotKeys.includes(key)) {
              console.log('缓存数据', cachedDataMap[key])
              this.$set(this.dataMap, key, { ...cachedDataMap[key] })
            }
          }

          // 确保当前选中的位置正确
          if (this.slotKeys.includes(this.currentSlotKey)) {
            this.updateCurrentPosition(this.currentSlotKey)
          } else if (this.slotKeys.length > 0) {
            this.updateCurrentPosition(this.slotKeys[0])
          }
          console.log('最终数据', this.dataMap)
        } catch (error) {
          console.error('加载缓存数据失败:', error)
        }
        this.$nextTick(() => {
          this.loadingCache = true
        })
      }
    }
  }
</script>

<template>
  <div>
    <!-- Banner位置选项卡, 模板4的时候不展示 -->
    <div class="banner-tabs" v-if="tempId !== 4">
      <el-tabs v-model="activeTab" @tab-click="slotKeyChange">
        <el-tab-pane
          v-for="item in slotKeys"
          :key="item"
          :label="positionTitle(item)"
          :name="item"
        />
      </el-tabs>
    </div>

    <!-- 每个位置的表单内容 -->
    <div v-for="key in slotKeys" :key="key" v-show="currentSlotKey === key">
      <!-- 简化模式下只显示默认banner选择 -->
      <div v-if="isSimpleMode">
        <el-form
          :ref="`${key}_bannerForm`"
          :model="dataMap[key]"
          :rules="rules"
          label-width="120px"
          size="small"
        >
          <el-form-item label="默认banner" prop="defAdId" v-if="tempId !== 4">
            <div style="display: flex; align-items: center">
              <div v-if="dataMap[key].defImgUrl">
                <img
                  :src="dataMap[key].defImgUrl"
                  style="width: 120px; height: 120px; object-fit: cover"
                />
                <div>{{ dataMap[key].defName }}</div>
              </div>
              <el-button type="primary" @click="openDefaultBannerDialog" style="margin-left: 20px"
                >选择/更换默认 banner</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </div>

      <!-- 完整模式 -->
      <div v-else>
        <JumpTem
          :value="dataMap[key]"
          @change="(newVal) => $set(dataMap, key, newVal)"
          :ref="`${key}_JumpTem`"
          :mark="key"
          v-if="loadingCache"
        >
          <template v-slot:banner>
            <el-form
              :ref="`${key}_bannerForm`"
              :model="dataMap[key]"
              :rules="rules"
              label-width="120px"
              size="small"
            >
              <!-- banner位置显示 -->
              <!--              <el-form-item label="banner 位置">-->
              <!--                <div>{{ dataMap[key].slotKey }}</div>-->
              <!--              </el-form-item>-->
              <!-- 默认banner选择 -->
              <el-form-item label="默认banner" prop="defAdId" v-if="tempId !== 4">
                <div style="display: flex; align-items: center">
                  <div v-if="dataMap[key].defImgUrl">
                    <img
                      :src="dataMap[key].defImgUrl"
                      style="width: 120px; height: 120px; object-fit: cover"
                    />
                    <div>{{ dataMap[key].defName }}</div>
                  </div>
                  <el-button
                    type="primary"
                    @click="openDefaultBannerDialog"
                    style="margin-left: 20px"
                    >选择/更换默认 banner</el-button
                  >
                  <div class="form-tip"> 配置 banner 前需选择备用默认 banner </div>
                </div>
              </el-form-item>

              <!-- banner名称 -->
              <el-form-item label="banner名称" prop="name">
                <el-input
                  v-model="dataMap[key].name"
                  placeholder="请输入banner名称"
                  maxlength="30"
                  show-word-limit
                  style="width: 400px"
                  v-no-emoji
                />
              </el-form-item>

              <!-- 权重 -->
              <el-form-item label="权重" prop="sort">
                <div style="display: flex">
                  <el-input-number v-model="dataMap[key].sort" :min="1" :max="10" />
                  <div class="form-tip" style="width: 450px">
                    （权重数值越小越靠前，banner优先级越高）
                  </div>
                </div>
              </el-form-item>

              <!-- 展示时间 -->
              <el-form-item label="展示时间" required prop="startTime">
                <el-date-picker
                  v-model="dataMap[key].dateRange"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="选择开始日期"
                  end-placeholder="选择结束日期"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptionStart()"
                  @change="(val) => handleDateRangeChange(val, key)"
                  style="width: 400px"
                  :default-time="['00:00:00', '23:59:59']"
                />
              </el-form-item>

              <!-- 展示渠道 -->
              <!--              <el-form-item label="展示渠道">-->
              <!--                <el-checkbox-group v-model="dataMap[key].displayChannelList">-->
              <!--                  <el-checkbox label="1">微信小程序</el-checkbox>-->
              <!--                  <el-checkbox label="2">APP</el-checkbox>-->
              <!--                  <el-checkbox label="4">支付宝小程序</el-checkbox>-->
              <!--                  <el-checkbox label="3">云闪付</el-checkbox>-->
              <!--                </el-checkbox-group>-->
              <!--              </el-form-item>-->

              <!-- 展示地区 -->
              <el-form-item
                label="展示地区"
                :prop="dataMap[key].allArea === 1 ? 'allArea' : 'areaIdList'"
              >
                <div>
                  <el-radio-group v-model="dataMap[key].allArea">
                    <el-radio :label="1">全部地区</el-radio>
                    <el-radio :label="0">部分地区</el-radio>
                  </el-radio-group>
                </div>
                <YdCitySelect
                  v-if="dataMap[key].allArea !== 1"
                  mode="2"
                  placeholder="请选择地区"
                  :customHttp="getDriverAreaTree"
                  :fieldFormat="fieldFormat"
                  v-model="dataMap[key].areaIdList"
                />
              </el-form-item>

              <!-- 标题文字图，除模板一外其他模板都没有该字段 -->
              <el-form-item label="标题文字图" prop="marketImgUrl" v-if="tempId === 1">
                <imageUpload
                  :imageList="dataMap[key].marketImgUrl ? [{ url: dataMap[key].marketImgUrl }] : []"
                  :limit="1"
                  :fileSize="1"
                  :isShowTip="true"
                  :WHtip="true"
                  :width="150"
                  :height="36"
                  :fileType="['png', 'jpg']"
                  accept=".jpg,.png"
                  :multiple="false"
                  @input="(val) => getImg(val, 'marketImgUrl', key)"
                  code="banner"
                />
              </el-form-item>

              <!-- banner图 -->
              <el-form-item label="banner图" prop="imgUrl">
                <imageUpload
                  :imageList="dataMap[key].imgUrl ? [{ url: dataMap[key].imgUrl }] : []"
                  :limit="1"
                  :fileSize="1"
                  :isShowTip="true"
                  :WHtip="true"
                  :width="width"
                  :height="height"
                  :fileType="['png', 'jpg']"
                  accept=".jpg,.png"
                  :multiple="false"
                  @input="(val) => getImg(val, 'imgUrl', key)"
                  code="banner"
                />
              </el-form-item>

              <!-- 营销文案，除模板一外其他模板都没有该字段 -->
              <el-form-item label="营销文案" prop="marketText" v-if="tempId === 1">
                <el-input
                  v-model="dataMap[key].marketText"
                  :rows="4"
                  placeholder="请输入"
                  maxlength="6"
                  show-word-limit
                  style="width: 400px"
                  v-no-emoji
                />
              </el-form-item>
            </el-form>
          </template>
        </JumpTem>
      </div>
    </div>

    <DefaultBannerDialog
      :visible.sync="defaultBannerDialogVisible"
      :value="
        currentSlotKey && dataMap[currentSlotKey] ? dataMap[currentSlotKey].defaultBanner : null
      "
      :slotKey="activeTab"
      @confirm="handleDefaultBannerConfirm"
    />
  </div>
</template>

<style scoped lang="scss">
  .banner-tabs {
    width: 100%;
    margin-bottom: 20px;
  }

  .upload-tip {
    color: #f56c6c;
    font-size: 12px;
    margin-top: 5px;
  }

  .form-tip {
    font-size: 12px;
    color: red;
    line-height: 1.5;
    margin-left: 10px;
  }
</style>
